import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-proba-mode-dialog',
  templateUrl: './proba-mode.dialog.html',
  styleUrls: ['./proba-mode.dialog.scss']
})
export class ProbaModeDialogComponent {
  public mode = 'class';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string },
    private dialogRef: MatDialogRef<ProbaModeDialogComponent>
  ) {
  }

  confirm() {
    this.dialogRef.close({mode: this.mode});
  }
}
